<div class="timeline-view" [style.height.px]="contentHeight()">
  <!-- Header Bar with Filters and Controls -->
  <div class="timeline-header">
    <div class="header-left">
      <span class="filter-label">Filter by</span>

      <!-- Error Badge -->
      <button
        class="filter-badge"
        [class.active]="filters().error"
        (click)="toggleFilter('error')"
      >
        <span class="badge-icon error">⊗</span>
        <span class="badge-count">{{ errorCount() }}</span>
      </button>

      <!-- Success Badge -->
      <button
        class="filter-badge"
        [class.active]="filters().api"
        (click)="toggleFilter('api')"
      >
        <span class="badge-icon success">✓</span>
        <span class="badge-count">{{ totalCount() }}</span>
      </button>

      <!-- Warning Badge -->
      <button
        class="filter-badge"
        [class.active]="filters().warn"
        (click)="toggleFilter('warn')"
      >
        <span class="badge-icon warning">⚠</span>
        <span class="badge-count">{{ warnCount() }}</span>
      </button>

      <!-- Info Badge -->
      <!-- <button
        class="filter-badge"
        [class.active]="filters().info"
        (click)="toggleFilter('info')"
      >
        <span class="badge-icon info">☐</span>
        <span class="badge-count">{{ infoCount() }}</span>
      </button> -->
    </div>

    <div class="header-right">
      <div class="search-container-left">
        <span class="search-icon fa fa-search"></span>
        <input
          type="text"
          placeholder="Search"
          [(ngModel)]="searchQuery"
          class="search-input"
        />
      </div>
      <!-- Zoom Controls -->
      <button class="zoom-btn" (click)="zoomOut()" title="Zoom out">−</button>
      <span class="zoom-level" (click)="resetZoom()">{{ zoomLevel() }}%</span>
      <button class="zoom-btn" (click)="zoomIn()" title="Zoom in">+</button>

      <!-- Clear Button -->
      <button class="clear-btn" (click)="clearTimeline()" title="Clear timeline">
        <span class="fa fa-ban"></span>
      </button>
    </div>
  </div>

  <!-- Splitter between Timeline and Details Panel -->
  @if (!selectedEvent()) {
    <!-- No Splitter - Show Timeline Only -->
    <div class="timeline-content" [style.height]="'calc(100% - 40px)'">
      @if (timelineRows().length === 0) {
        <!-- Empty State -->
        <div class="empty-state">
          <div class="empty-icon">📊</div>
          <div class="empty-title">No timeline events yet</div>
          <div class="empty-description">
            Timeline will show API calls, state changes, and other events as they occur
          </div>
        </div>
      } @else {
        <!-- Time Scale -->
        <div class="time-scale" [style.min-width.%]="zoomLevel() > 100 ? zoomLevel() : null">
          <div class="time-scale-grid">
            <div class="time-scale-spacer"></div>
            <div class="time-scale-track">
              @for (marker of timeMarkers(); track marker.time) {
                <div
                  class="time-marker"
                  [style.left.%]="marker.position"
                >
                  <span class="time-label">{{ marker.label }}</span>
                  <div class="time-line"></div>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Timeline Rows Container -->
        <div class="timeline-rows" [style.min-width.%]="zoomLevel() > 100 ? zoomLevel() : null">
          @for (row of timelineRows(); track row.id) {
            <div class="timeline-row">
              <!-- Left Column: Event Name with Status -->
              <div class="row-name">
                <span class="row-icon">{{ row.icon }}</span>
                <span class="row-text" (click)="selectEvent(row.event)">{{ row.name }}</span>
                <span
                  class="status-icon"
                  [class]="getStatusClass(row.event.status)"
                >
                  {{ getStatusIcon(row.event.status) }}
                </span>
              </div>

              <!-- Right Column: Timeline Track -->
              <div class="row-timeline">
                <!-- Timeline Bar -->
                <div
                  class="timeline-bar"
                  [class]="getStatusClass(row.event.status)"
                  [style.left.%]="row.position"
                  [style.width.%]="row.width"
                  (click)="selectEvent(row.event)"
                  [title]="row.event.title + ' - ' + formatDuration(row.event.duration || 0)"
                >
                  <span class="bar-duration">
                    {{ formatDuration(row.event.duration || 0) }}
                  </span>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <!-- Splitter Active - Show Timeline + Details -->
    <ejs-splitter height='calc(100% - 40px)' separatorSize=2 width='100%' orientation='Vertical'>
      <e-panes>
        <!-- Timeline Pane -->
        <e-pane size='60%' min='100px'>
          <ng-template #content>
            <div class="timeline-content">
              @if (timelineRows().length === 0) {
                <!-- Empty State -->
                <div class="empty-state">
                  <div class="empty-icon">📊</div>
                  <div class="empty-title">No timeline events yet</div>
                  <div class="empty-description">
                    Timeline will show API calls, state changes, and other events as they occur
                  </div>
                </div>
              } @else {
                <!-- Time Scale -->
                <div class="time-scale" [style.min-width.%]="zoomLevel() > 100 ? zoomLevel() : null">
                  <div class="time-scale-grid">
                    <div class="time-scale-spacer"></div>
                    <div class="time-scale-track">
                      @for (marker of timeMarkers(); track marker.time) {
                        <div
                          class="time-marker"
                          [style.left.%]="marker.position"
                        >
                          <span class="time-label">{{ marker.label }}</span>
                          <div class="time-line"></div>
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- Timeline Rows Container -->
                <div class="timeline-rows" [style.min-width.%]="zoomLevel() > 100 ? zoomLevel() : null">
                  @for (row of timelineRows(); track row.id) {
                    <div class="timeline-row">
                      <!-- Left Column: Event Name with Status -->
                      <div class="row-name">
                        <span class="row-icon">{{ row.icon }}</span>
                        <span class="row-text" (click)="selectEvent(row.event)">{{ row.name }}</span>
                        <span
                          class="status-icon"
                          [class]="getStatusClass(row.event.status)"
                        >
                          {{ getStatusIcon(row.event.status) }}
                        </span>
                      </div>

                      <!-- Right Column: Timeline Track -->
                      <div class="row-timeline">
                        <!-- Timeline Bar -->
                        <div
                          class="timeline-bar"
                          [class]="getStatusClass(row.event.status)"
                          [style.left.%]="row.position"
                          [style.width.%]="row.width"
                          (click)="selectEvent(row.event)"
                          [title]="row.event.title + ' - ' + formatDuration(row.event.duration || 0)"
                        >
                          <span class="bar-duration">
                            {{ formatDuration(row.event.duration || 0) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </ng-template>
        </e-pane>

        <!-- Details Panel Pane -->
        <e-pane size='40%' min='100px'>
          <ng-template #content>
            <div class="details-panel">
              <div class="details-header">
                <div class="details-title">
                  <span class="details-icon">{{ getTypeIcon(selectedEvent()!.type) }}</span>
                  <span class="details-name">{{ selectedEvent()!.title }}</span>
                </div>
                <button class="close-btn" (click)="closeDetails()">✕</button>
              </div>

              <div class="details-content">
                <!-- Type and Status in one row (side by side) -->
                <div class="detail-row inline-grid">
                  <span class="detail-label">Type:</span>
                  <span class="detail-value">{{ selectedEvent()!.type }}</span>
                  <span class="detail-label">Status:</span>
                  <span class="detail-value" [class]="getStatusClass(selectedEvent()!.status)">
                    {{ selectedEvent()!.status || 'N/A' }}
                  </span>
                </div>

                <!-- Timestamp and Duration in one row (side by side) -->
                <div class="detail-row inline-grid">
                  <span class="detail-label">Timestamp:</span>
                  <span class="detail-value">{{ formatTimeLabel(selectedEvent()!.timestamp) }}</span>
                  @if (selectedEvent()!.duration) {
                    <span class="detail-label">Duration:</span>
                    <span class="detail-value">{{ formatDuration(selectedEvent()!.duration) }}</span>
                  }
                </div>

                <!-- Description (full width) -->
                <!-- <div class="detail-row">
                  <span class="detail-label">Description:</span>
                  <span class="detail-value">{{ selectedEvent()!.description }}</span>
                </div> -->

                <!-- Data Tabs (Headers, Request, Response) -->
                @if (selectedEvent()!.data) {
                  <div class="data-tabs-container">
                    <!-- Tab Buttons -->
                    <div class="data-tabs">
                      @if (selectedEvent()!.data.headers) {
                        <button
                          class="data-tab-button"
                          [class.active]="activeDataTab() === 'headers'"
                          (click)="switchDataTab('headers')"
                        >
                          Headers
                        </button>
                      }
                      @if (selectedEvent()!.data.requestBody) {
                        <button
                          class="data-tab-button"
                          [class.active]="activeDataTab() === 'request'"
                          (click)="switchDataTab('request')"
                        >
                          Request
                        </button>
                      }
                      @if (selectedEvent()!.data.responseBody) {
                        <button
                          class="data-tab-button"
                          [class.active]="activeDataTab() === 'response'"
                          (click)="switchDataTab('response')"
                        >
                          Response
                        </button>
                      }
                    </div>

                    <!-- Tab Content -->
                    <div class="data-tab-content">
                      @if (activeDataTab() === 'headers' && selectedEvent()!.data.headers) {
                        <div class="detail-data-tree">
                          <app-json-tree [data]="selectedEvent()!.data.headers" [searchQuery]="''" />
                        </div>
                      }
                      @if (activeDataTab() === 'request' && selectedEvent()!.data.requestBody) {
                        <div class="detail-data-tree">
                          <app-json-tree [data]="getParsedData(selectedEvent()!.data.requestBody)" [searchQuery]="''" />
                        </div>
                      }
                      @if (activeDataTab() === 'response' && selectedEvent()!.data.responseBody) {
                        <div class="detail-data-tree">
                          @if (selectedEvent()!.data.responseBody._isBlob) {
                            <!-- Blob Response Display -->
                            <div class="blob-response">
                              <div class="blob-meta">
                                <span class="blob-type">{{ selectedEvent()!.data.responseBody.type }}</span>
                                <span class="blob-size">{{ selectedEvent()!.data.responseBody.sizeFormatted }}</span>
                              </div>
                              @if (selectedEvent()!.data.responseBody._blobUrl) {
                                <img class="blob-preview" [src]="selectedEvent()!.data.responseBody._blobUrl" alt="Response preview" />
                              }
                            </div>
                          } @else {
                            <app-json-tree [data]="getParsedData(selectedEvent()!.data.responseBody)" [searchQuery]="''" />
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </ng-template>
        </e-pane>
      </e-panes>
    </ejs-splitter>
  }
</div>
